var gcert = gcert || {};
gcert.review = gcert.review || {};

gcert.review = {
	init: function () {
		gcert.review.bindToggleButton();
		gcert.review.bindCouponSubmit();
		gcert.review.bindCancelButton();
	},
	bindCancelButton() {
		let cancelButton = document.querySelector('.coupon_cancel_info a');
		if (!cancelButton) {
			return;
		}
		cancelButton.addEventListener('click', (e) => {
			e.preventDefault();
			$.ajax({
				url: cancelButton.getAttribute('href'),
				success: function (res) {
					let parser = new DOMParser();
					let htmlDoc = parser.parseFromString(res, 'text/html');
					const couponSection = htmlDoc.querySelector('.coupon');
					document.querySelector('.coupon').replaceWith(couponSection);
					document.querySelector('.couponInfo').classList.add('active');
					const newPriceToPay = htmlDoc.querySelector('.paymentForm .totals .price');
					document.querySelector('.paymentForm .totals .price').textContent = newPriceToPay.textContent;
					gcert.review.bindToggleButton();
					gcert.review.bindCouponSubmit();
				},
			});
		});
	},
	bindToggleButton() {
		let toggleButton = document.querySelector('.couponToggle button');
		let couponInfo = document.querySelector('.couponInfo');
		toggleButton.addEventListener('click', (e) => {
			e.preventDefault();
			toggleButton.classList.toggle('active');
			couponInfo.classList.toggle('active');
		});
	},
	bindCouponSubmit() {
		let couponInfo = document.querySelector('.couponInfo');
		let couponInfoForm = couponInfo.querySelector('form');
		let couponInfoFormSubmitButton = couponInfo.querySelector('form button[type="submit"]');
		couponInfoFormSubmitButton.addEventListener('click', (e) => {
			e.preventDefault();
			$.ajax({
				url: couponInfoForm.action,
				type: 'POST',
				data: $('.couponInfo form').serialize(),
				success: function (res) {
					const message = res.message;
					let messageElm = document.querySelector('.message');
					if (message === 'Afsláttarkóði ekki gildur') {
						document.querySelector('.box.review .coupon').classList.add('invalid');
						messageElm.textContent = message;
					}
					if (message === 'Enginn afsláttarkóði gefinn upp') {
						document.querySelector('.box.review .coupon').classList.add('invalid');
						messageElm.textContent = message;
					}
					if (message === 'Afsláttarkóði virkjaður') {
						$.ajax({
							url: window.location,
							success: function (res) {
								let parser = new DOMParser();
								let htmlDoc = parser.parseFromString(res, 'text/html');
								const hasCouponContent = htmlDoc.querySelector('.has_coupon');
								const hasCoupon = document.querySelector('.has_coupon');
								const newPriceToPay = htmlDoc.querySelector('.paymentForm .totals .price');
								if (!hasCoupon && hasCouponContent) {
									couponInfoForm.appendChild(hasCouponContent);
								}
								else if(hasCouponContent) {
									hasCoupon.replaceWith(hasCouponContent);
								}
								site.maxHeight.setHeight('.couponInfo');
								document.querySelector('.paymentForm .totals .price').textContent = newPriceToPay.textContent;
								document.querySelector('.box.review .coupon').classList.add('active');
								messageElm.textContent = '';
								gcert.review.bindCancelButton();
							},
						});
					}
				},
			});
		});
	},
};
